import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom'; // REMOVED: No longer directly used
import Button from '../components/Button'; // Assuming you have a Button component

const NotFoundContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh; /* Adjust as needed */
  text-align: center;
  padding: 2rem;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.primary};
`;

const StatusCode = styled.h1`
  font-size: 8rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.secondary};
  text-shadow: 2px 2px 5px rgba(0,0,0,0.1);

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    font-size: 6rem;
  }
`;

const Message = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: ${props => props.theme.colors.primary};

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    font-size: 1.8rem;
  }
`;

const SubMessage = styled.p`
  font-size: 1.2rem;
  color: ${props => props.theme.colors.text};
  max-width: 600px;
  margin-bottom: 2.5rem;
  line-height: 1.6;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    font-size: 1rem;
  }
`;

const NotFoundPage = () => {
  return (
    <NotFoundContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <StatusCode>404</StatusCode>
      <Message>Page Not Found</Message>
      <SubMessage>
        Oops! It looks like you've stumbled upon a page that doesn't exist. We're actively working to improve our website. Thanks for your patience!
      </SubMessage>
      <Button to="/" color="primary">
        Go to Homepage
      </Button>
    </NotFoundContainer>
  );
};

export default NotFoundPage;